module.exports = __webpack_public_path__ + "img/difficultyLevel_2_gray.4fa809fa.svg";